/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const block = sqliteTable(
  "block",
  {
    id: text("id").primaryKey(),
    lesson_id: text("lesson_id"),
    course_id: text("course_id"),
    kind: text("kind"),
    position: integer("position"),
    weight: integer("weight"),
    content: text("content"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE lesson_id = ? ORDER BY position in player/editor */
    index("block_by_lesson").on(table.lesson_id, table.position),
  ],
);

export const certificate = sqliteTable(
  "certificate",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    learner_name: text("learner_name"),
    course_title: text("course_title"),
    course_version: integer("course_version"),
    org_name: text("org_name"),
    issued_at: text("issued_at"),
    revoked_at: text("revoked_at"),
  },
  (table) => [
    /** WHERE user_id = ? (my certificates) and lookup by course */
    index("certificate_by_user").on(table.user_id, table.course_id),
  ],
);

export const course = sqliteTable(
  "course",
  {
    id: text("id").primaryKey(),
    author_id: text("author_id"),
    title: text("title"),
    description: text("description"),
    slug: text("slug"),
    category: text("category"),
    cover_image: text("cover_image"),
    language: text("language"),
    visibility: text("visibility"),
    version: integer("version"),
    published_at: text("published_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE author_id = ? in authoring editor */
    index("course_by_author").on(table.author_id),
    /** Catalogue: WHERE visibility = 'public' */
    index("course_by_visibility").on(table.visibility),
  ],
);

export const course_editor = sqliteTable("course_editor", {
  id: text("id").primaryKey(),
  course_id: text("course_id"),
  user_id: text("user_id"),
  created_at: text("created_at"),
});

export const course_organization = sqliteTable("course_organization", {
  id: text("id").primaryKey(),
  course_id: text("course_id"),
  organization_id: text("organization_id"),
  created_at: text("created_at"),
});

export const enrollment = sqliteTable(
  "enrollment",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE user_id = ? in my courses + getHasLocalDataQuery */
    index("enrollment_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

export const leaderboard_entry = sqliteTable(
  "leaderboard_entry",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    league_id: text("league_id"),
    display_name: text("display_name"),
    total_xp: integer("total_xp"),
    opted_in: integer("opted_in"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE league_id = ? ORDER BY total_xp in league leaderboard */
    index("leaderboard_entry_by_league").on(table.league_id, table.total_xp),
  ],
);

export const learner_stats = sqliteTable("learner_stats", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  total_xp: integer("total_xp"),
  lessons_done: integer("lessons_done"),
  current_streak: integer("current_streak"),
  longest_streak: integer("longest_streak"),
  last_active_date: text("last_active_date"),
  updated_at: text("updated_at"),
});

export const lesson = sqliteTable(
  "lesson",
  {
    id: text("id").primaryKey(),
    unit_id: text("unit_id"),
    course_id: text("course_id"),
    title: text("title"),
    position: integer("position"),
    xp_reward: integer("xp_reward"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE unit_id = ? ORDER BY position */
    index("lesson_by_unit").on(table.unit_id, table.position),
    /** WHERE course_id = ? */
    index("lesson_by_course").on(table.course_id),
  ],
);

export const lesson_progress = sqliteTable(
  "lesson_progress",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    course_id: text("course_id"),
    lesson_id: text("lesson_id"),
    status: text("status"),
    score: real("score"),
    xp_awarded: integer("xp_awarded"),
    attempts: integer("attempts"),
    last_block_id: text("last_block_id"),
    fraud_flags: text("fraud_flags"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    completed_at: text("completed_at"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    responses: text("responses"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    claimed_score: real("claimed_score"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    started_at: integer("started_at"),
    /** Client-only: travels in sync's opData; Postgres doesn't have it. */
    finished_at: integer("finished_at"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("lesson_progress_by_user").on(table.user_id),
    /** WHERE user_id = ? AND course_id = ? in course progress */
    index("lesson_progress_by_course").on(table.user_id, table.course_id),
  ],
);

// Small dataset per user — indexes not needed for now.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Small dataset — indexes not needed for now.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

export const unit = sqliteTable(
  "unit",
  {
    id: text("id").primaryKey(),
    course_id: text("course_id"),
    title: text("title"),
    position: integer("position"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
  },
  (table) => [
    /** WHERE course_id = ? ORDER BY position in course tree */
    index("unit_by_course").on(table.course_id, table.position),
  ],
);

// Only 1 row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  leaderboard_opt_in: integer("leaderboard_opt_in"),
});

export const drizzleSchema = {
  block,
  certificate,
  course,
  course_editor,
  course_organization,
  enrollment,
  font_family,
  font_variant,
  leaderboard_entry,
  learner_stats,
  lesson,
  lesson_progress,
  member,
  organization,
  session,
  themes,
  unit,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = ["enrollment", "learner_stats", "lesson_progress"] as const;

export type Block = InferSelectModel<typeof block>;
export type BlockInsert = InferInsertModel<typeof block>;
export type BlockRecord = Block;
export type Certificate = InferSelectModel<typeof certificate>;
export type CertificateInsert = InferInsertModel<typeof certificate>;
export type CertificateRecord = Certificate;
export type Course = InferSelectModel<typeof course>;
export type CourseInsert = InferInsertModel<typeof course>;
export type CourseRecord = Course;
export type CourseEditor = InferSelectModel<typeof course_editor>;
export type CourseEditorInsert = InferInsertModel<typeof course_editor>;
export type CourseEditorRecord = CourseEditor;
export type CourseOrganization = InferSelectModel<typeof course_organization>;
export type CourseOrganizationInsert = InferInsertModel<typeof course_organization>;
export type CourseOrganizationRecord = CourseOrganization;
export type Enrollment = InferSelectModel<typeof enrollment>;
export type EnrollmentInsert = InferInsertModel<typeof enrollment>;
export type EnrollmentRecord = Enrollment;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type LeaderboardEntryRow = InferSelectModel<typeof leaderboard_entry>;
export type LeaderboardEntryRowInsert = InferInsertModel<typeof leaderboard_entry>;
export type LeaderboardEntryRowRecord = LeaderboardEntryRow;
export type LearnerStats = InferSelectModel<typeof learner_stats>;
export type LearnerStatsInsert = InferInsertModel<typeof learner_stats>;
export type LearnerStatsRecord = LearnerStats;
export type Lesson = InferSelectModel<typeof lesson>;
export type LessonInsert = InferInsertModel<typeof lesson>;
export type LessonRecord = Lesson;
export type LessonProgress = InferSelectModel<typeof lesson_progress>;
export type LessonProgressInsert = InferInsertModel<typeof lesson_progress>;
export type LessonProgressRecord = LessonProgress;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type Unit = InferSelectModel<typeof unit>;
export type UnitInsert = InferInsertModel<typeof unit>;
export type UnitRecord = Unit;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
